import React, { useEffect, useState } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getContractByCaseId } from "./redux/contract/thunks";
import TabBar from "./components/navbar/Navbar";
import {
  routeList,
  ROUTE_LOGIN,
  ROUTE_ADMINS_MENU,
  ROUTE_BILLING,
  ROUTE_SUPPLIER_PAYMENT_ORDERS,
  ROUTE_CLIENTS,
} from "./components/routes/routesConstants";
import { BillingManagement } from "./components/billing/BillingManagement";
import { SupplierPaymentOrders } from "./components/supplier/SupplierPaymentOrders";
import { TableWrapper } from "./components/table/TableWrapper";
import { Login } from "./components/login/Login";
import { ForceChangePassword } from "./components/login/ForceChangePassword";
import { PrivateRoute } from "./components/routes/PrivateRoute";
import { Modal } from "./components/common/Modal";
import { PanelGrid } from "./components/panel/PanelGrid";
import { AdminWrapper } from "./components/admin/AdminWrapper";
import { locale, loadMessages } from "devextreme/localization";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { setEntryParams } from "./redux/appState/appStateSlice";
import { createCallIfNotExists } from "./redux/calls/thunks";
import { selectAppState } from "./redux/appState/selectors";
import { blockCase } from "./redux/currentCase/thunks";
import { getCaseByCallId } from "./redux/cases/thunks";
import { associateCall } from "./redux/calls/thunks";
import { openModal } from "./redux/modal/modalSlice";
import { selectCurrentCase } from "./redux/currentCase/selectors";

import { QUERY_PUT_SETCASEATTENDANCE } from "./fetch/constantQueries";
import { selectContractCase } from "./redux/contract/selectors";
import { getUrl } from "./fetch/basicThunk";
import { getUserData } from "./redux/authentication/thunks";
import {
  isTokenExpired,
  isUserInRoles,
  parseJwtToken,
} from "./commonFunctions/commonFunctions";
import {
  selectLoadingUserRoles,
  selectUser,
  selectUserLoading,
} from "./redux/authentication/selectors";
import { Dashboard } from "./components/dashboard/Dashboard";
import { ADMIN, MANAGER } from "./Constantes/userRoles";
import { CampaignStatistics } from "./components/admin/campaigns/CampaignStatus";

import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

function App() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const appState = useSelector(selectAppState);
  const currentCase = useSelector(selectCurrentCase);
  const contractCase = useSelector(selectContractCase);
  const [work, setWork] = useState(null);
  const [newCase, setNewCase] = useState(false);
  const [previousActive, setPreviousCase] = useState(null);
  const loadedUserData = useSelector(selectUserLoading);
  const loadingUserRoles = useSelector(selectLoadingUserRoles);
  const user = useSelector(selectUser);
  const history = useHistory();

  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(customParseFormat);

  const initialLanguage =
    localStorage.getItem("apoloCRM_Language") ||
    user?.user?.preferredLanguage ||
    i18n.language ||
    "pt-BR";
  locale(initialLanguage);

  loadMessages({
    es: {
      "dxCalendar-todayButtonText": "Hoy",
    },
  });

  React.useEffect(() => {
    if (authentication() && user && user?.user?.preferredLanguage) {
      i18n.changeLanguage(user.user.preferredLanguage);
      locale(user.user.preferredLanguage);
      localStorage.removeItem("apoloCRM_Language");
      localStorage.setItem("apoloCRM_Language", user.user.preferredLanguage);
    }
  }, [user]);

  React.useEffect(() => {
    if (authentication() && !appState.callId) {
      if (loadingUserRoles !== "succeeded" && loadingUserRoles !== "loading") {
        const token = parseJwtToken();
        dispatch(getUserData({ param: token.sub }));
      }

      if (isTokenExpired()) {
        localStorage.removeItem('apoloCRM_Token');
        history.push(ROUTE_LOGIN);
      }

      const entryParams = location.search;
      const searchParams = new URLSearchParams(entryParams.toLowerCase());
      const callId = searchParams.get("callid");
      let codCliente = searchParams.get("cod_cliente");

      if (!callId && !codCliente) return;

      if (callId == codCliente) {
        codCliente = null;
      }

      if (callId || codCliente) {
        dispatch(setEntryParams({ callId, clientCode: codCliente }));
      }

      let caseId = null;
      if (!codCliente && !appState.clientCode && callId) {
        dispatch(createCallIfNotExists({ query: `?callId=${callId}` })).then(
          () =>
            dispatch(getCaseByCallId(callId)).then((data) => {
              if (data.payload) {
                blockAndGetContract(data.payload);
              } else {
                dispatch(
                  openModal({ type: "warning", message: data.error.message })
                );
              }
            })
        );
      } else {
        caseId = codCliente || appState.codCliente;

        if (callId) {
          dispatch(
            associateCall({ query: `?caseId=${caseId}&callId=${callId}` })
          ).then(() => {
            blockAndGetContract(caseId);
          });
        } else {
          blockAndGetContract(caseId);
        }
      }
    }
  }, [location]);

  function blockAndGetContract(caseId) {
    dispatch(blockCase(+caseId)).then(() => {
      dispatch(getContractByCaseId({ query: `?caseId=${caseId}` }));
    });
  }

  function authentication() {
    let token = localStorage.getItem("apoloCRM_Token");
    if (!token || !localStorage.getItem("apoloCRM_Token")) {
      return false;
    }
    return true;
  }

  // //inicializa el worker cuando se monta al aplicación:
  // useEffect(() => {
  //   const worker = new Worker("workerfile.js");
  //   setWork(worker);
  // }, []);

  // //envía mensaje para iniciar bucle de peticiones cuando se carga un caso
  // useEffect(() => {
  //   if (work && currentCase) {
  //     const isFrontUser = getAttendanceType();
  //     work.postMessage({
  //       token: localStorage.getItem("apoloCRM_Token"),
  //       url: getUrl() + QUERY_PUT_SETCASEATTENDANCE,
  //       body: {
  //         caseId: currentCase.caseId,
  //         isOpen: true,
  //         isNewCase: newCase,
  //         isFrontUser: isFrontUser,
  //       },
  //     });
  //     work.onmessage = (e) => {};
  //     setPreviousCase(currentCase);
  //   }
  // }, [work]);

  // //terminamos el worker cuando el usuario accede a alguna de las pantallas de administración
  // useEffect(() => {
  //   if (work && currentCase && isAdminLocation()) {
  //     terminateWorker();
  //     setWork(null);
  //   }
  // }, [location]);

  function getAttendanceType() {
    const initialCaseStateId = contractCase.stateId;
    let isFrontUser = initialCaseStateId === 2;
    return isFrontUser;
  }

  // //termina el worker cuando se cambia el caso
  // useEffect(() => {
  //   if (currentCase) {
  //     if (work) {
  //       terminateWorker();
  //       if (previousActive?.caseId == 0) {
  //         setNewCase(false);
  //       }
  //     }
  //     let worker = new Worker("workerfile.js");
  //     setWork(worker);
  //   }
  // }, [currentCase?.caseId]);

  function handleNewCase(newCase) {
    setNewCase(newCase);
  }

  function terminateWorker() {
    const isFrontUser = getAttendanceType();
    work.postMessage({
      token: localStorage.getItem("apoloCRM_Token"),
      url: getUrl() + QUERY_PUT_SETCASEATTENDANCE,
      body: {
        caseId:
          currentCase?.caseId != 0
            ? currentCase?.caseId
            : previousActive?.caseId,
        isOpen: previousActive?.caseId == 0 && newCase ? true : false,
        isNewCase: newCase,
        isFrontUser: isFrontUser,
      },
    });
    work.onmessage = (e) => {
      work.terminate();
    };
  }

  function isAdminLocation() {
    const { pathname } = location;
    return (
      pathname.includes("/admin/") ||
      pathname.includes("campaign") ||
      pathname.includes("dashboard")
    );
  }

  return (
    <div className="App">
      <Modal />
      <header className="App-header">
        <TabBar />
      </header>
      <div id="main">
        <Switch>
          <PrivateRoute
            allowedRoles={routeList[0].allowedRoles}
            path={routeList[0].path}
            component={<Dashboard />}
            authed={authentication}
          />
          <PrivateRoute
            allowedRoles={routeList[2].allowedRoles}
            path={routeList[2].path}
            component={<TableWrapper key={1} type={"Casos"} />}
            authed={authentication}
          />
          {/* <PrivateRoute
            allowedRoles={[ADMIN, MANAGER]}
            path={routeList[3].path}
            component={<CampaignStatistics />}
            authed={authentication}
          /> */}
          <PrivateRoute
            allowedRoles={routeList[3].allowedRoles}
            strictRoles={routeList[3].strictRoles}
            path={routeList[3].path}
            component={<BillingManagement />}
            authed={authentication}
          />
          <PrivateRoute
            allowedRoles={routeList[4].allowedRoles}
            path={routeList[4].path}
            component={<SupplierPaymentOrders />}
            authed={authentication}
          />
          <PrivateRoute
            allowedRoles={routeList[5].allowedRoles}
            path={routeList[5].path}
            component={<TableWrapper key={4} type={"Clientes"} />}
            authed={authentication}
          />
          {/* <PrivateRoute path={routeList[4].path} component={<TableWrapper key={2} type={"Talleres"}/>} authed={authentication}/>
          <PrivateRoute path={routeList[5].path} component={<TableWrapper key={3} type={"Flotas"}/>} authed={authentication}/>
          <PrivateRoute path={routeList[7].path} component={<TableWrapper key={5} type={"Itvs"}/>} authed={authentication}/>           */}
          <PrivateRoute
            path={ROUTE_ADMINS_MENU}
            component={<AdminWrapper />}
            authed={authentication}
          />
          <Route path={ROUTE_LOGIN} component={Login} />
          <PrivateRoute
            path="/force-change-password"
            component={<ForceChangePassword />}
            authed={authentication}
          />
          <PrivateRoute
            path={routeList[1].path}
            component={<PanelGrid handleNewCase={handleNewCase} />}
            authed={authentication}
          />
        </Switch>
      </div>
    </div>
  );
}

export default App;
